import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export const useFetchProfitDetail = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (model: any) => {
        const response = await get("dashboard/profit/detail?userAccountId=" + model.userAccountId);
        return response;
    }, options);
};

export const useFetchLastWeekProfitChartDetail = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (model: any) => {
        const response = await get("dashboard/lastweek/trades/detail?userAccountId=" + model.userAccountId);
        return response;
    }, options);
};

export const useFetchLastWeekOverviewChartDetail = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (model: any) => {
        const response = await get("dashboard/lastweek/trades/overview?userAccountId=" + model.userAccountId);
        return response;
    }, options);
};

export const useFetchTopProfitableTrades = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (model: any) => {
        const response = await get("dashboard/positions/profitable-trades?userAccountId=" + model.userAccountId + "&filterRangeValue=" + model.filterRangeValue);
        return response;
    }, options);
};

export const useFetchTopStopLossTrades = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (model: any) => {
        const response = await get("dashboard/positions/stoploss-trades?userAccountId=" + model.userAccountId + "&filterRangeValue=" + model.filterRangeValue);
        return response;
    }, options);
};

export const useFetchTopProfitableStockSymbol = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (model: any) => {
        const response = await get("dashboard/positions/profitable/stock-symbol?userAccountId=" + model.userAccountId + "&startDate=" + model.startDate + "&endDate=" + model.endDate);
        return response;
    }, options);
};